export enum MlSocieties {
  ABM = 'abm',
  NRJ = 'nrj',
  //BB = 'bb',
}
